<script>
export default {
  computed: {
    loggedUser () {
      if (this.$store.getters.getAutenticacion) {
        return this.$store.getters.getAutenticacion.usuario
      } else {
        return null
      }
    },
    nombreEmpresa () {
      if (this.$store.getters.getAutenticacion) {
        return this.$store.getters.getAutenticacion.nombreEmpresa
      } else {
        return null
      }
    },
    idOrganizacion () {
      if (this.$store.getters.getAutenticacion) {
        return this.$store.getters.getAutenticacion.organizacion
      } else {
        return null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/globals/mx-auth.vue